// extracted by mini-css-extract-plugin
export var active = "_lm-2";
export var recordingDot = "_lm-1";
export var recordingIndicator = "_lm-0";